import '../../scss/acf-blocks/block-contact-form.scss';
import { detectOs } from '../components/detect-os';
import initCountryStateSelect from '../components/country-state-select';

const initContactForm = () => {
    // set platform
    const buttons = document.querySelectorAll("input[name='platform']");
    buttons &&
        buttons.forEach((btn) => {
            if (btn.dataset.platform === detectOs()) {
                btn.setAttribute('checked', 'checked');
            }
        });

    // Initializes the country and state/province select elements and adds an event listener for changes.
    initCountryStateSelect();
};

document.defaultView.addEventListener(
    'DOMContentLoaded',
    initContactForm,
    false
);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', initContactForm);
}
